//Autocomplete Moteur
function Autocomplete(url, idSearch, idSearchLabel) {
    let inputLabel = document.getElementById(idSearchLabel);
    const navigationKeys = ["ArrowDown", "ArrowUp", "Enter", "Escape", "Tab"];

    inputLabel.setAttribute("role", "combobox");
    inputLabel.setAttribute("aria-autocomplete", "list");
    inputLabel.setAttribute("aria-expanded", "false");
    inputLabel.setAttribute("aria-controls", idSearch + "-autocomplete");
    inputLabel.setAttribute("autocomplete", "off");

    //Ajoute la saisie de l'utilisateur sans selection de l'autocomplete
    inputLabel.addEventListener("keyup", function (event) {
        if (navigationKeys.includes(event.key)) {
            return;
        }

        let referenceVal = Slugify(inputLabel.value);

        //Synchroniser la valeur
        document.getElementById(idSearch).value = inputLabel.value;

        //Rechercher à partir de 2 caractères
        if (referenceVal.length > 2) {
            let http = new XMLHttpRequest();
            http.open("post", url.replace('--search--', referenceVal), true);
            http.setRequestHeader("Content-type", "application/x-www-form-urlencoded");

            http.onload = function () {
                if (http.readyState === 4 && http.status === 200) {
                    let results = JSON.parse(http.responseText);
                    if (results.length !== 0) {
                        displayResults(results, idSearch, idSearchLabel);
                    }
                }
            };

            http.send();
        }
    });

    inputLabel.addEventListener("keydown", function (event) {
        const div = getResults(idSearch);
        if (!div || div.classList.contains('hidden')) {
            return;
        }

        const options = Array.from(div.querySelectorAll('[role="option"]'));
        const activeIndex = options.findIndex(option => option.classList.contains('is-active'));

        switch (event.key) {
            case "ArrowDown":
                event.preventDefault();
                setActiveOption(options, activeIndex < options.length - 1 ? activeIndex + 1 : 0, inputLabel);
                break;
            case "ArrowUp":
                event.preventDefault();
                setActiveOption(options, activeIndex > 0 ? activeIndex - 1 : options.length - 1, inputLabel);
                break;
            case "Enter":
                if (activeIndex >= 0) {
                    event.preventDefault();
                    selectOption(options[activeIndex], idSearch, idSearchLabel);
                }
                break;
            case "Escape":
            case "Tab":
                hideResults(idSearch, idSearchLabel);
                break;
        }
    });

    //Masquer les résultats en cliquant hors de la div
    document.addEventListener("click", function (event) {
        let div = getResults(idSearch);

        if (div && !div.contains(event.target) && event.target !== inputLabel) {
            hideResults(idSearch, idSearchLabel);
        }
    });
}

function getResults(idSearch) {
    const formGroup = document.getElementById(idSearch).parentElement;
    return formGroup.querySelector(`.autocompleteResults`);
}

function setActiveOption(options, index, inputLabel) {
    options.forEach((option, i) => {
        option.classList.toggle('is-active', i === index);
        option.setAttribute("aria-selected", i === index ? "true" : "false");
    });
    inputLabel.setAttribute("aria-activedescendant", options[index].id);
    options[index].scrollIntoView({ block: "nearest" });
}

function selectOption(option, idSearch, idSearchLabel) {
    document.getElementById(idSearchLabel).value = option.getAttribute("data-label");

    let slug = option.getAttribute("data-slug");
    let postalCode = option.getAttribute("data-postal-code");
    let value = postalCode ? slug + "-" + postalCode : slug;

    document.getElementById(idSearch).value = value;
    hideResults(idSearch, idSearchLabel);
}

function hideResults(idSearch, idSearchLabel) {
    const div = getResults(idSearch);
    if (div) {
        div.classList.add('hidden');
    }

    const inputLabel = document.getElementById(idSearchLabel);
    inputLabel.setAttribute("aria-expanded", "false");
    inputLabel.removeAttribute("aria-activedescendant");
}

//Affichage des resultats (div)
function displayResults(results, idSearch, idSearchLabel) {
    let div = getResults(idSearch);

    //Créer un div si elle n'existe pas
    if (!div) {
        div = document.createElement('div');
        div.classList.add('autocompleteResults');
        document.body.appendChild(div);

        insertAfter(document.getElementById(idSearch), div)
    } else {
        div.classList.remove('hidden');
    }

    // Supprimez les anciens résultats
    div.innerHTML = '';

    const inputLabel = document.getElementById(idSearchLabel);
    inputLabel.setAttribute("aria-expanded", "true");
    inputLabel.removeAttribute("aria-activedescendant");

    let ul = document.createElement("ul")
    ul.id = idSearch + "-autocomplete";
    ul.setAttribute("role", "listbox");

    div.appendChild(ul);

    //Ajoute les résultats
    results.forEach((result, index) => {
        let li = document.createElement("li");
        li.id = idSearch + "-autocomplete-" + index;
        li.setAttribute("role", "option");
        li.setAttribute("aria-selected", "false");
        ul.appendChild(li);

        let p = document.createElement("p");
        let label = result.PostalCode !== null ? result.Label + " " + result.PostalCode : result.Label;

        p.textContent = label;
        li.setAttribute("data-label", label);
        li.setAttribute("data-slug", result.Slug);
        li.setAttribute("data-postal-code", result.PostalCode || "");

        li.appendChild(p);

        li.addEventListener("click", function () {
            selectOption(li, idSearch, idSearchLabel);
        });
    });
}

//Fonction de formatage d'un slug
function Slugify(str) {
    str = str.replace(/^\s+|\s+$/g, '');

    str = str.toLowerCase();

    let from = "ÁÄÂÀÃÅČÇĆĎÉĚËÈÊẼĔȆÍÌÎÏŇÑÓÖÒÔÕØŘŔŠŤÚŮÜÙÛÝŸŽáäâàãåčçćďéěëèêẽĕȇíìîïňñóöòôõøðřŕšťúůüùûýÿžþÞĐđßÆa·/_,:;";
    let to = "AAAAAACCCDEEEEEEEEIIIINNOOOOOORRSTUUUUUYYZaaaaaacccdeeeeeeeeiiiinnooooooorrstuuuuuyyzbBDdBAa------";
    for (let i = 0, l = from.length; i < l; i++) {
        str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
    }

    str = str.replace(/[^a-z0-9 -]/g, '')
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-');

    return str;
}

//Insert la div autocomplete après le moteur
function insertAfter(referenceNode, newNode) {
    referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
}